<section class="users-page">
  <div class="users-page-header">
    <h4>Users</h4>
    <p>Manage and review user profiles.</p>
  </div>
  <app-user-list></app-user-list>
</section>